import React from 'react';
import AttritionReportPicker from './components/AttritionReportPicker';

function SPOCAttritionReport() {
  return (
    <div style={{ padding: 24 }}>
      <AttritionReportPicker
        companiesApiPath="/api/spoc/attrition-report/companies"
        reportApiPath="/api/spoc/attrition-report"
        tokenKey="gogig_spoc_access"
        title="Employee Attrition Report"
        subtitle="Your assigned companies with stipend CSV. Attrition matches candidates by mobile (same / joined / left). Slips are not used."
        redirectOnAuthFailure={false}
      />
    </div>
  );
}

export default SPOCAttritionReport;
